/** Validated ISO calendar dates have no timezone and must not shift with the device locale. */
export function formatComplianceDate(isoDate: string): string {
  return isoDate.split('-').reverse().join('.')
}

export function formatComplianceDateTime(
  instant: string,
  timezone: string,
  includeSeconds = false,
): string {
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: timezone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...(includeSeconds ? { second: '2-digit' } : {}),
    hour12: false,
  }).format(new Date(instant))
}
